export default __webpack_public_path__ + "static/GT-Super-Display-Regular-1543000c0a51d52ac504823631258848.woff2";